import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  currentLanguage = '';
  private readonly translate = inject(TranslateService);

  quickLinks = [
    { title: 'footer_navigation.link_home', routeName: '', isPage: false },
    { title: 'footer_navigation.link_about', routeName: 'about-us', isPage: false },
    { title: 'footer_navigation.link_work', routeName: 'our-programs', isPage: false },
    { title: 'footer_navigation.link_gallery', routeName: 'gallery', isPage: true },
    // TODO: no dedicated "Get Involved" page in the Figma design yet — links home until one is designed
    { title: 'footer_navigation.link_involved', routeName: '', isPage: false },
    { title: 'footer_navigation.link_contact', routeName: 'get-in-touch', isPage: false },
  ];

  constructor() {
    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });
  }
}
